import React from 'react';
import { authService } from '../services/authService';

const UserProfile = ({ user, onSignOut }) => {
  const handleSignOut = async () => {
    try {
      await authService.signOut();
      if (onSignOut) {
        onSignOut();
      }
    } catch (error) {
      console.error('Sign out failed:', error);
    }
  };

  if (!user) {
    return null;
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      padding: '10px 20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      border: '1px solid #dee2e6'
    }}>
      {user.picture && (
        <img
          src={user.picture}
          alt={user.name}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            objectFit: 'cover'
          }}
        />
      )}
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
          {user.name}
        </div>
        <div style={{ fontSize: '12px', color: '#666' }}>
          {user.email}
        </div>
      </div>
      <button
        onClick={handleSignOut}
        style={{
          padding: '6px 12px',
          border: '1px solid #dc3545',
          backgroundColor: '#dc3545',
          color: 'white',
          borderRadius: '4px',
          fontSize: '12px',
          cursor: 'pointer'
        }}
        title="Sign Out"
      >
        Sign Out
      </button>
    </div>
  );
};

export default UserProfile;